import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";

import { Observable, of } from "rxjs";
import { AppConstants } from "../../app.constants";
import { map } from "rxjs/operators";
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ErrorHandlerService } from "src/app/core/services/error-handler.service";

@Injectable({
  providedIn: "root",
})
export class LifecycleintellegenceService {
  api_drugdata = "/assets/mockdata/getDrugData.json";

  constructor(private http: HttpClient, private router: Router, private errorHandlerService: ErrorHandlerService) { }

  getNdaData(searchValue): Observable<any[]> {
    console.log("called in seervice", searchValue);
    let paramsInput = new HttpParams();
    paramsInput = paramsInput.append("brand_name", searchValue);
    return this.http.get<any[]>(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.LIFEMOLECULE.GET}`,
      { params: paramsInput }
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getNdaMoleculeData(data): Observable<any[]> {
    return this.http.post<any[]>(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.SEARCHMOLECULE.POST}`,
      data
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getRldMoleculeData(data): Observable<any[]> {
    return this.http.post<any[]>(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.SEARCHMOLECULERLD.POST}`,
      data
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  saveMoleculeRld(data): Observable<any[]> {
    console.log(data);
    return this.http.post<any[]>(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.CALCULATEMOLECULERLD.POST}`,
      data
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  saveMoleculeData(data): Observable<any[]> {
    return this.http.post<any[]>(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.SAVEMOLECULEAPI.POST}`,
      data
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  saveEstRld(data): Observable<any[]> {
    return this.http.post<any[]>(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.SAVEMOLECULERLD.POST}`,
      data
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  checkCaseOfAPI(data): Observable<any[]> {
    return this.http.post<any[]>(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.CHECKCASEAPI.POST}`,
      data
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getDrugData(ndaValue): Observable<any[]> {
    let paramsInput = new HttpParams();
    paramsInput = paramsInput.append("nda", ndaValue);
    //   return this.http.get<any[]>(this.api_drugdata)
    return this.http.get<any[]>(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.LIFECYCLE.LIFE_DETAILS}`,
      { params: paramsInput }
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
    // return this.http.get<any[]>(`${AppConstants.API_ENDPOINT1}${AppConstants.API.DETAILS.GETDATA}`, { params: paramsInput })
  }

  savenovelpolymorphData(data): Observable<any[]> {
    return this.http.post<any[]>(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.SAVEPOLYMORPH.POST}`,
      data
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  /** To Fetch the column Name */
  getValidation(data): Observable<any[]> {
    console.log("data getvalidation", data);
    return this.http.post<any[]>(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.VALIDATEAPI.POST}`,
      { data }
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  /** To Update the Molecule Tablets */
  moleculeupdate(data): Observable<any[]> {
    return this.http.put<any[]>(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.UPDATEMOLECULEAPI.PUT}`,
      { data }
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }
  /** To Update the Molecule data on click of approve/reject */
  updateMoleculeData(data): Observable<any[]> {
    return this.http.put<any[]>(
      `${AppConstants.API_ENDPOINT1}${AppConstants.API.UPDATEMOLECULEDATA.PUT}`,
      { data }
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  uploadExcel(formData): Observable<any[]> {
    const headers = new HttpHeaders();
    headers.set("Content-Type", "multipart/form-data");
    // return this.http.post<any[]>(`${AppConstants.API_ENDPOINT}${AppConstants.API.UPLOADEXCEL.POST}`, {formData })

    return this.http
      .post(
        `${AppConstants.API_ENDPOINT}${AppConstants.API.UPLOADEXCEL.POST}`,
        formData,
        {
          headers,
        }
      )
      .pipe(map((res: any) => res), catchError((error) => this.errorHandlerService.handleError(error)));
  }

  // To download Full file
  getdownloadfile(ndaValue): Observable<any[]> {
    return this.http.post<any[]>(
      `${AppConstants.API_ENDPOINT1}${AppConstants.API.DOWNLOADFILE.POST}`,
      ndaValue
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  // To download selected data
  downloadSelected(selectedData): Observable<any[]> {
    return this.http.post<any[]>(
      `${AppConstants.API_ENDPOINT1}${AppConstants.API.DOWNLOADFILE.DOWLOAD_SELECTED_POST}`,
      selectedData
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  addPara(data): Observable<any> {
    const params = new HttpParams()
      .set("type", data.type)
      .set("brand_name", data.brand_name);

    return this.http.put<any[]>(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.PARA.PUT +
      "/?brand_name=" +
      data.brand_name +
      "&type=" +
      data.type
      }`,
      { params }
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  /** To SEND A MAIL for admin to approve */
  SendEmail(data): Observable<any[]> {
    return this.http.post<any[]>(
      `${AppConstants.API_ENDPOINT1}${AppConstants.API.SENDEMAIL.POST}`,
      { data }
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getEditedData(active_ingredient, brand_name, ndaValue): Observable<any[]> {
    let paramsInput = new HttpParams();
    paramsInput = paramsInput.append("active_ingredient", active_ingredient);
    paramsInput = paramsInput.append("brand_name_proprietary_name", brand_name);
    paramsInput = paramsInput.append("nda", ndaValue);
    return this.http.get<any[]>(
      `${AppConstants.API_ENDPOINT1}${AppConstants.API.GETEDITEDDATA.GET}`,
      { params: paramsInput }
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  // SECTION WISE API"S
  getFirstSection(ndaValue): Observable<any[]> {
    let paramsInput = new HttpParams();
    paramsInput = paramsInput.append("nda_number", ndaValue);
    return this.http.get<any[]>(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.LIFECYCLE.LIFE_INNOVATOR_BRAND_API}`,
      { params: paramsInput }
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getSecondSection(ndaValue): Observable<any[]> {
    let paramsInput = new HttpParams();
    paramsInput = paramsInput.append("nda_number", ndaValue);
    return this.http.get<any[]>(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.LIFECYCLE.LIFE_PATENT_INFORMATION}`,
      { params: paramsInput }
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getThirdSection(ndaValue): Observable<any[]> {
    let paramsInput = new HttpParams();
    paramsInput = paramsInput.append("nda_number", ndaValue);
    return this.http.get<any[]>(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.LIFECYCLE.LIFE_REGULATORY_INFORMATION}`,
      { params: paramsInput }
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getFourthSection(ndaValue): Observable<any[]> {
    let paramsInput = new HttpParams();
    paramsInput = paramsInput.append("nda_number", ndaValue);
    return this.http.get<any[]>(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.LIFECYCLE.LIFE_CLINICAL_INFORMATION}`,
      { params: paramsInput }
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getFifthSection(ndaValue): Observable<any[]> {
    let paramsInput = new HttpParams();
    paramsInput = paramsInput.append("nda_number", ndaValue);
    return this.http.get<any[]>(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.LIFECYCLE.LIFE_API_INFORMATION}`,
      { params: paramsInput }
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getSixthSection(ndaValue): Observable<any[]> {
    let paramsInput = new HttpParams();
    paramsInput = paramsInput.append("nda_number", ndaValue);
    return this.http.get<any[]>(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.LIFECYCLE.LIFE_FORMULATION_INFORMATION}`,
      { params: paramsInput }
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getSeventhSection(ndaValue): Observable<any[]> {
    let paramsInput = new HttpParams();
    paramsInput = paramsInput.append("nda_number", ndaValue);
    return this.http.get<any[]>(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.LIFECYCLE.LIFE_COMPITITIVE_INTELLIGENCE}`,
      { params: paramsInput }
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getEightSection(ndaValue): Observable<any[]> {
    let paramsInput = new HttpParams();
    paramsInput = paramsInput.append("nda_number", ndaValue);
    return this.http.get<any[]>(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.LIFECYCLE.LIFE_EXECUTIVE_SUMMARY}`,
      { params: paramsInput }
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  /** To SEND A MAIL for admin to approve */
  sendSectionOneEmail(
    active_ingredient,
    brand_name,
    ndaValue,
    data
  ): Observable<any[]> {
    let paramsInput = new HttpParams();
    paramsInput = paramsInput.append("nda_number", ndaValue);
    paramsInput = paramsInput.append("brand_name", brand_name);
    paramsInput = paramsInput.append("active_ingredient", active_ingredient);
    return this.http.put<any[]>(
      `${AppConstants.API_ENDPOINT1}${AppConstants.API.SENDEMAIL.INNOVATOR_BRAND_EDIT_API}`,
      { data },
      { params: paramsInput }
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  sectionOneEditedData(
    active_ingredient,
    brand_name,
    ndaValue
  ): Observable<any[]> {
    let paramsInput = new HttpParams();
    paramsInput = paramsInput.append("active_ingredient", active_ingredient);
    paramsInput = paramsInput.append("brand_name", brand_name);
    paramsInput = paramsInput.append("nda_number", ndaValue);
    return this.http.get<any[]>(
      `${AppConstants.API_ENDPOINT1}${AppConstants.API.GETEDITEDDATA.GET_SECTION_ONE_DATA}`,
      { params: paramsInput }
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  /** To Update the Molecule data on click of approve/reject */
  updateSectionOneMoleculeData(data): Observable<any[]> {
    return this.http.put<any[]>(
      `${AppConstants.API_ENDPOINT1}${AppConstants.API.UPDATEMOLECULEDATA.SECTION_ONE_PUT}`,
      { data }
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }
  getCommercialData(data): Observable<any[]> {
    //   return this.http.get<any[]>(this.api_drugdata)
    return this.http.post<any[]>(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.CommercialAPI.POST}`,
      data
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
    // return this.http.get<any[]>(`${AppConstants.API_ENDPOINT1}${AppConstants.API.DETAILS.GETDATA}`, { params: paramsInput })
  }
  UpdateCommercialData(data): Observable<any[]> {
    //   return this.http.get<any[]>(this.api_drugdata)
    return this.http.post<any[]>(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.UpdateCommercialAPI.POST}`,
      data
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
    // return this.http.get<any[]>(`${AppConstants.API_ENDPOINT1}${AppConstants.API.DETAILS.GETDATA}`, { params: paramsInput })
  }
  GetNda(brand_name): Observable<any[]> {
    let paramsInput = new HttpParams();
    paramsInput = paramsInput.append("brand_name", brand_name);
    //   return this.http.get<any[]>(this.api_drugdata)
    return this.http.get<any[]>(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.GETNDA.GET}`,
      { params: paramsInput }
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
    // return this.http.get<any[]>(`${AppConstants.API_ENDPOINT1}${AppConstants.API.DETAILS.GETDATA}`, { params: paramsInput })
  }
  uploadPDF(data): Observable<any[]> {
    return this.http.post<any[]>(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.UPLOADPDF.POST}`,
      data
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }
  SalesandVolume(data): Observable<any[]> {
    let formData: FormData = new FormData();
    formData.append("nda_number", data.nda_number);
    formData.append("brand_name", data.brand_name);
    return this.http.post<any[]>(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.SALESANDVOLUME.POST}`,
      formData
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }
  uploadSalesExcel(data): Observable<any[]> {
    let formData: FormData = new FormData();
    formData.append("nda_number", data.nda_number);
    formData.append("brand_name", data.brand_name);
    formData.append("excel_sheet", data.excel_sheet); //
    return this.http.post<any[]>(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.UPLOADSALESEXCEL.POST}`,
      formData
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }
  UpdateSalesandVolume(data): Observable<any[]> {
    //   return this.http.get<any[]>(this.api_drugdata)
    return this.http.post<any[]>(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.UPDATESALESVOLUME.POST}`,
      data
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
    // return this.http.get<any[]>(`${AppConstants.API_ENDPOINT1}${AppConstants.API.DETAILS.GETDATA}`, { params: paramsInput })
  }

  UserRegister(data): Observable<any[]> {
    //   return this.http.get<any[]>(this.api_drugdata)
    return this.http.post<any[]>(
      `${AppConstants.API_ENDPOINT3}${AppConstants.API.USERREGISTER.POST}`,
      data
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
    // return this.http.get<any[]>(`${AppConstants.API_ENDPOINT1}${AppConstants.API.DETAILS.GETDATA}`, { params: paramsInput })
  }
}
